import { render } from "./SelectedCar.vue?vue&type=template&id=6f7493c6&ts=true"
import script from "./SelectedCar.vue?vue&type=script&lang=ts"
export * from "./SelectedCar.vue?vue&type=script&lang=ts"

import "./SelectedCar.vue?vue&type=style&index=0&id=6f7493c6&lang=css"

import exportComponent from "/usr/home/demon/projects/driven/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__